var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breaksCreatePermission)?_c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[_c('break-tab',{staticClass:"mt-4"})],1)],1):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }